module.exports = __webpack_public_path__ + "img/il_Onboarding_Folders.5eee7a25.svg";